import tw, { styled } from "twin.macro";

export const StyledInput = styled.button`
  ${tw`flex w-full gap-3.5 justify-between items-center border-b border-black 
      text-black font-medium text-lg leading-5  min-w-min pb-2.5`}
`;
